// src/config/index.js

/**
 * @file index.js
 * @description Centralized configuration file for the frontend application.
 * Contains configurations for backend API, authentication services (Casdoor),
 * and other global settings.
 */

// Configuration for backend API
//export const API_BASE_URL = 'http://101.133.174.140:8302/api/v1';
export const API_BASE_URL =     'https://api.eyuanquant.com/api/v1';
//export const API_BASE_URL =     'https://api-preview.eyuanquant.com/api/v1';

// Log the API_BASE_URL for quick troubleshooting
console.log('API_BASE_URL:', API_BASE_URL);

// Configuration for Casdoor Authentication
// Updated to match deployment environment
export const casdoorConfig = {
  serverUrl: 'https://auth.eyuanquant.com',
  clientId: 'bbe1c98b34866fbe9906',
  organizationName: 'MyTradingAppOrg',
  appName: 'TradingPlatformMVP',
  redirectPath: '/callback',
};


export default {
  API_BASE_URL,
  casdoorConfig,
  // OTHER,
};
